export default __webpack_public_path__ + "static/media/RecommendationWithEdit.b7554f7c.png";